import {
  addToWishlistCreator,
  fetchWishlistActionCreator,
  REHYDRATED,
  removeFromWishlistCreator,
  WISHLIST_TOGGLE,
} from '../actions';
import { isProductWishlisted } from '../selectors';
import getLocalStorageObject from '../helpers/getLocalStorageObject';

const STORAGE_ITEMS_KEY = 'ngStorage-ti_wishlist-items';
const STORAGE_UPDATE_KEY = 'ngStorage-notify_ti_wishlist_update';

const getRawWishListItems = () => getLocalStorageObject(STORAGE_ITEMS_KEY) || [];

const transformWishlistItems = raw => (
  raw.reduce((result, { config_sku }) => ({ // eslint-disable-line camelcase
    ...result,
    [config_sku]: true,
  }), {})
);

const fetchWishlistItems = async () => transformWishlistItems(getRawWishListItems());

const storeWishlistItems = async items => {
  global.localStorage.setItem(STORAGE_ITEMS_KEY, JSON.stringify(items));

  const time = new Date().getTime();
  const randomNumber = Math.floor(Math.random() * 10000);
  global.localStorage.setItem(STORAGE_UPDATE_KEY, JSON.stringify({
    status: 'updated',
    count: items.length,
    time,
    window_id: `${randomNumber}_${time}`,
  }));

  return transformWishlistItems(items);
};

const dispatchWishlistToggleAction = (store, action) => {
  const { sku } = action.payload;
  const wasWishlisted = isProductWishlisted(store.getState(), sku);
  const items = getRawWishListItems();
  if (wasWishlisted) {
    store.dispatch(removeFromWishlistCreator(
      sku,
      storeWishlistItems(items.filter(
        ({ config_sku }) => config_sku !== sku, // eslint-disable-line camelcase
      )),
    ));
  } else {
    store.dispatch(addToWishlistCreator(
      sku,
      storeWishlistItems([
        ...items,
        { config_sku: sku },
      ]),
    ));
  }
};

export default store => next => action => {
  const ret = next(action);
  switch (action.type) {
    case REHYDRATED:
      store.dispatch(fetchWishlistActionCreator(fetchWishlistItems()));
      break;
    case WISHLIST_TOGGLE:
      dispatchWishlistToggleAction(store, action);
      break;
    // no default
  }
  return ret;
};
